import React, { useEffect, useRef, useState } from "react";

const Stepper = ({
  activeTab,
  step1Desc,
  onClickStep1,
  onClickStep2,
  step2Desc,
  noCurrsor = false,
}) => {
  const stepRefs = useRef([]);
  const containerRef = useRef(null);
  const [lineDims, setLineDims] = useState({ left: 0, width: 0 });
  const progressWidth = lineDims.width * ((activeTab - 1) / 1);

  const calculateLine = () => {
    const first = stepRefs.current[0];
    const second = stepRefs.current[1];
    const container = containerRef.current;

    if (first && second && container) {
      const containerLeft = container.getBoundingClientRect().left;
      const gap = 30; // gap from both ends

      const firstCenter =
        first.getBoundingClientRect().left -
        containerLeft +
        first.offsetWidth / 2;

      const secondCenter =
        second.getBoundingClientRect().left -
        containerLeft +
        second.offsetWidth / 2;

      setLineDims({
        left: firstCenter + gap,
        width: secondCenter - firstCenter - 2 * gap,
      });
    }
  };

  useEffect(() => {
    calculateLine();
    const resizeObserver = new ResizeObserver(() => {
      calculateLine();
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="w-100 d-flex justify-content-center mb-3">
      <div
        ref={containerRef}
        className="position-relative d-flex justify-content-between align-items-start flex-wrap"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        <div
          className="stepper-line-bg position-absolute top-0"
          style={{
            marginTop: "12px",
            left: `${lineDims.left}px`,
            width: `${lineDims.width}px`,
          }}
        />
        <div
          className="stepper-line-progress position-absolute top-0"
          style={{
            marginTop: "12px",
            left: `${lineDims.left}px`,
            width: `${progressWidth}px`,
          }}
        />
        <div
          ref={(el) => (stepRefs.current[0] = el)}
          className="text-center position-relative z-3 flex-grow-1"
          onClick={onClickStep1}
          role="button"
          style={{
            minWidth: "120px",
            cursor: noCurrsor ? "default" : "pointer",
          }}
        >
          <div
            className={`step-pill mx-auto mb-2 fs-6 fw-bold rounded-circle ${
              activeTab >= 1
                ? "text-white"
                : "inactive-pill text-muted border border-2"
            }`}
            style={{ cursor: noCurrsor ? "default" : "pointer" }}
          ></div>
          <div className="step-description text-dark">
            <div className="rv-sub-label rv-label-muted">Step 1</div>
            <div>{step1Desc}</div>
          </div>
        </div>

        <div
          ref={(el) => (stepRefs.current[1] = el)}
          className="text-center position-relative z-3 flex-grow-1"
          onClick={onClickStep2}
          role="button"
          style={{
            minWidth: "120px",
            cursor: noCurrsor ? "default" : "pointer",
          }}
        >
          <div
            className={`step-pill mx-auto mb-2 fs-6 fw-bold rounded-circle ${
              activeTab >= 2 ? "text-white" : "inactive-pill text-muted"
            }`}
            style={{ cursor: noCurrsor ? "default" : "pointer" }}
          ></div>
          <div className="step-description text-dark">
            <div className="rv-sub-label rv-label-muted">Step 2</div>
            <div>{step2Desc}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
